/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-24 22:20:26
 */

import CompareTaskConfirm from '../compareTaskConfirm';
import { default as CellOperate } from 'src/components/agGridComponent/cellOperate';
import { ColDefCustom, default as AgGridVueCustomTsx } from 'src/components/agGridCustom/agGridVueCustomTsx';
import CompareTaskConfirmApi, { CompareTaskConfirmDOI } from '../api/compareTaskConfirmApi';
import ListPageService from 'src/types/ListPage';
import override from 'src/dectorators/override';
import { QueryFormVOI } from 'src/components/queryForm/queryForm';
import CellRenderTsx from 'src/components/agGridComponent/cellRenderTsx';
import EnumCompareTaskStatus, { EnumCompareTaskDealStatus } from 'src/enums/enumCompareTaskStatus';
import alertConfirmTaskModal from '../confirmTaskModal';
import EnumOperates from 'src/enums/enumOperates';
import CommonSelect from 'src/components/SelectCustom/commonSelect';
import DatePicker from 'src/types/iview/DatePicker';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import Input from 'src/types/iview/Input';
import { IconBtnItem } from 'src/components/iconBtnGroup/iconBtnGroup';
import { Toast } from 'src/util/toast';
import alertBatchConfirmModal from '../batchConfirmModal';

export default class CompareTaskConfirmService extends ListPageService {
    ctx: CompareTaskConfirm;

    constructor(ctx: CompareTaskConfirm) {
        super();
        this.ctx = ctx;
    }

    // 是否是申报
    get isConfirm() {
        return this.ctx.$route.name === 'maintenance-manage-compare-task-confirm';
    }

    @override
    createColumns(): ColDefCustom[] {
        let t = this;
        return [
            {
                headerName: '通知单号',
                field: 'inform_number',
                minWidth: 120,
            },
            {
                headerName: '任务号',
                field: 'task_number',
                minWidth: 120,
                cellRendererFramework: CellRenderTsx,
                cellRendererFrameworkOpt: {
                    cellRender(h, params) {
                        let data: CompareTaskConfirmDOI.RowDataI = params.data;
                        return (
                            <div
                                class="wqms-cursor wqms-link"
                                on-click={() => {
                                    alertConfirmTaskModal(EnumOperates.Detail.getName(), data.id, data.device_id);
                                }}
                            >
                                {data.task_number}
                            </div>
                        );
                    },
                },
            },
            {
                headerName: '发起人',
                field: 'initiator',
                minWidth: 100,
            },
            {
                headerName: '发起时间',
                field: 'sponsor_datetime',
                minWidth: 170,
            },
            {
                headerName: '对比站点',
                field: 'device_name',
                minWidth: 140,
            },
            {
                headerName: '确认人',
                field: 'affirm_people',
                minWidth: 100,
            },
            {
                headerName: '确认时间',
                field: 'affirm_datatime',
                minWidth: 170,
            },
            {
                headerName: '处理人',
                field: 'dispose_people',
                minWidth: 100,
            },
            {
                headerName: '处理时间',
                field: 'dispose_datatime',
                minWidth: 170,
            },
            {
                headerName: '状态',
                field: 'status',
                minWidth: 80,
                cellRenderer(params) {
                    let data: CompareTaskConfirmDOI.RowDataI = params.data;
                    return t.isConfirm
                        ? EnumCompareTaskStatus.findId(data.ops_leader_status).getName()
                        : EnumCompareTaskDealStatus.findId(data.ops_status).getName();
                },
            },

            {
                headerName: '操作',
                field: 'operate',
                minWidth: 120,
                maxWidth: 120,
                pinned:window.innerWidth<1600? 'right':false,
                cellRendererFramework: CellOperate,
                cellRendererFrameworkOpt: [
                    {
                        text: '确认',
                        hide: !t.isConfirm,
                        disabled(params) {
                            let data: CompareTaskConfirmDOI.RowDataI = params.data;
                            return EnumCompareTaskStatus.待确定.getId() !== data.ops_leader_status;
                        },
                        async click(params) {
                            let data: CompareTaskConfirmDOI.RowDataI = params.data;
                            let res = await alertConfirmTaskModal(EnumOperates.Confirm.getName(), data.id, data.device_id);
                            if (res) {
                                t.searchTable();
                            }
                        },
                    },
                    {
                        text: '派发任务',
                        hide: !t.isConfirm,
                        disabled(params) {
                            let data: CompareTaskConfirmDOI.RowDataI = params.data;
                            return EnumCompareTaskStatus.待派发.getId() !== data.ops_leader_status;
                        },
                        async click(params) {
                            let data: CompareTaskConfirmDOI.RowDataI = params.data;
                            let res = await alertConfirmTaskModal(EnumOperates.Distribute.getName(), data.id, data.device_id);
                            if (res) {
                                t.searchTable();
                            }
                        },
                    },
                    {
                        text: '处理',
                        hide: t.isConfirm,
                        disabled(params) {
                            let data: CompareTaskConfirmDOI.RowDataI = params.data;
                            return EnumCompareTaskDealStatus.未处理.getId() !== data.ops_status;
                        },
                        async click(params) {
                            let data: CompareTaskConfirmDOI.RowDataI = params.data;
                            let res = await alertConfirmTaskModal(EnumOperates.Deal.getName(), data.id, data.device_id);
                            if (res) {
                                t.searchTable();
                            }
                        },
                    },
                ],
            },
        ];
    }

    @override
    creatQueryForm(): QueryFormVOI.DateItemType[] {
        let t = this
        return [
            {
                component: CommonSelect,
                label: '状态：',
                field: 'status',
                props: { value: null, dataSource: t.isConfirm?EnumCompareTaskStatus.getList():EnumCompareTaskDealStatus.getList() },
            },
            {
                component: DatePicker,
                label: '发起时间',
                field: 'time',
                width: 300,
                timeType: 'number',
                realField: ['start_time', 'end_time'],
                props: { value: DateTimeUtil.getDayInterval(7), type: 'daterange', format: 'yyyy-MM-dd', placeholder: '请选择时间' },
            },
            {
                component: Input,
                labelWidth: 20,
                label: '',
                field: 'keyword',
                props: { value: '', placeholder: '请输入' },
            },
        ];
    }

    @override
    initSearchParams(): void {
        this.ctx.searchParams = this.ctx.queryForm.getQueryObj<CompareTaskConfirmDOI.QueryRowDataParamsI>();
        this.ctx.currentPage = 1;
    }

    @override
    createBtnGroup(): Array<IconBtnItem> {
        let t = this;
        return [
            {
                text: '批量确认',
                async onClick() {
                    
                      let gridOptions: any = t.ctx.gridOptions;
                      let selectRows: CompareTaskConfirmDOI.RowDataI[] = gridOptions.api.getSelectedRows();
                      if (selectRows.length === 0) {
                          return Toast.warning('请选择要操作的数据');
                      }
                      if(selectRows.some(data=> EnumCompareTaskStatus.待确定.getId() !== data.ops_leader_status)) {
                          return Toast.warning('已确认的任务无法重新确认！');
                      }
                      let ids: number[] = selectRows.map(item => item.id);
                      let res = await alertBatchConfirmModal(ids);
                    if (res) {
                        t.searchTable();
                    }
                },
            },
        ]
    }

    @override
    async searchTable() {
        let ctx = this.ctx;
        let ag = this.ctx.$refs.ag as AgGridVueCustomTsx;
        ag.showLoading();
        let { code, data } = await CompareTaskConfirmApi.searchList(
            {
                ...ctx.searchParams,
                page_size: ctx.pageSize,
                page_index: ctx.currentPage,
            },
            this.isConfirm,
        );
        ag.hideLoading();

        if (code === 0) {
            ctx.rowData = data.data_info || [];
            ctx.total = data.page_count;
        }
    }
}
